<template>
  <div class="cpm-wrapper">
    <div class="cpm-body">
      <ul class="step-list">
        <li class="step">
          <div class="step-header">
            <div class="step-top">
              <img class="step-icon" :src="require('@/assets/img/check-list-icon.png')" alt="" />
              <strong class="step-text">信息核对</strong>
              <div class="blue-line"></div>
            </div>
            <div class="subtitle">转账汇款至商家旗下指定对公账号</div>
          </div>
          <div v-if="payId === 2" class="step-body">
            <div class="step-con confrim-info-sec">
              <p class="subtitle sure">请确认</p>
              <p class="names">户名、账号、开户行名称</p>
              <div class="acccount">
                <div class="item-label">户名：</div>
                <div class="item-value">{{ accountInfo.accountName }}</div>
              </div>
              <div class="acccount">
                <div class="item-label">账号：</div>
                <div class="item-value" id="orderSn">{{ accountInfo.bankCardNo }}</div>
              </div>
              <div class="acccount">
                <div class="item-label">开户行：</div>
                <div class="item-value">{{ accountInfo.branchBank }}</div>
              </div>
            </div>
          </div>
        </li>
        <li class="step">
          <div class="step-header">
            <div class="step-top">
              <img class="step-icon" :src="require('@/assets/img/check-list-icon-2.png')" alt="" />
              <strong class="step-text">保存支付凭证</strong>
              <div class="blue-line"></div>
            </div>
            <div class="subtitle">支付凭证（电子回单）示例</div>
          </div>
          <div class="step-body">
            <div class="step-con pay-file-sec">
              <div class="zhifu-img-wrapper">
                <el-image style="width: 245px; height: 103px" :src="require('@/assets/img/bank_detail.png')"></el-image>
                <p class="see-big-img" @click="showBig">查看大图</p>
              </div>
            </div>
          </div>
        </li>
        <li class="step">
          <div class="step-header">
            <div class="step-top">
              <img class="step-icon" :src="require('@/assets/img/check-list-icon-2.png')" alt="" />
              <strong class="step-text">上传凭证</strong>
              <div class="blue-line"></div>
            </div>
            <div class="subtitle">到详情页上传支付凭证</div>
          </div>
          <div class="step-body">
            <div class="step-con upload-file-sec">
              <div class="zhifu-img-wrapper">
                <img :src="require('@/assets/img/order_detail.png')" alt="" />
              </div>
            </div>
          </div>
        </li>
        <li class="step">
          <div class="step-header">
            <div class="step-top">
              <img class="step-icon" :src="require('@/assets/img/check-list-icon-2.png')" alt="" />
              <strong class="step-text">完成</strong>
            </div>
            <div class="subtitle">审核完成支付成功</div>
          </div>
          <div class="step-body">
            <div class="step-con pay-complete">
              <div class="zhifu-img-wrapper">
                <img class="step-icon" :src="require('@/assets/img/success-icon.png')" alt="" />
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accountInfo: {
      type: Object,
      default: () => {}
    },
    payId: {
      type: Number,
      default: 2
    }
  },
  methods: {
    showBig() {
      this.$previewImg({
        url: require('@/assets/img/bank_detail.png')
      });
    }
  }
};
</script>

<style lang="scss" scoped>
div.cpm-wrapper {
  margin-top: 60px;
  margin-left: 24px;
  div.cpm-body {
    ul.step-list {
      display: flex;
      li.step {
        margin-right: 16px;
        div.step-header {
          .step-top {
            display: flex;
            align-items: center;
            .step-icon {
              width: 24px;
              height: 24px;
            }
            .step-text {
              flex-shrink: 0;
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              margin: 0 8px;
            }
            .blue-line {
              width: 180px;
              height: 1px;
              border: 1px solid #0091ff;
            }
          }
          .subtitle {
            margin-top: 16px;
            color: #9a9a9a;
            font-size: 12px;
            margin-bottom: 12px;
          }
        }

        div.step-body {
          .confrim-info-sec {
            .subtitle {
              font-size: 12px;
              color: #9a9a9a;
              margin-bottom: 12px;
              &.sure {
                margin-bottom: 8px;
              }
            }
            .names {
              font-size: 12px;
              color: #333333;
            }
            .acccount {
              margin-top: 12px;
              font-size: 12px;
              color: #333333;
              display: flex;
              align-items: center;
              .item-label {
                // width: 48px;
                height: 18px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #8c8c8c;
                line-height: 18px;
              }
              .item-value {
                height: 18px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #595959;
                line-height: 18px;
              }
            }
          }
          .pay-file-sec {
            .zhifu-img-wrapper {
              position: relative;
              width: 245px;
              height: 103px;
              border: 1px solid #dfdfdf;
              cursor: pointer;
              img {
                width: 100%;
                height: 100%;
              }
              .see-big-img {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 64px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                color: #ffffff;
                font-size: 12px;
                background: rgba(0, 0, 0, 0.5);
              }
            }
          }
          .upload-file-sec {
            .zhifu-img-wrapper {
              img {
                width: 88px;
                height: 103px;
              }
            }
          }
          .pay-complete {
            .zhifu-img-wrapper {
              text-align: left;
              img {
                width: 20px;
                height: 20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
